import { Link } from 'react-router-dom';
import { LayersIcon, PlusIcon } from 'lucide-react';
import { ProductImage } from '../../ui/ProductImage';
import { PageHeader } from '../ui/PageHeader';
import { OfferTabs } from './OfferTabs';
import { EmptyState } from '../ui/EmptyState';
import { plural } from '../../core/format/text';
import { useAdmin } from '../AdminContext';
import { tierIn } from '../../data/gifts';
import { errorCount, routineChecks } from './catalogRules';
import { btnPrimary } from '../ui/styles';
import { euro } from '../../core/format/currency';
import { monthsLabel } from '../../utils/catalog';

/** Alle protocollen. De prijs is altijd de som van de producten. */
export function Routines() {
  const {
    catalog,
    index,
    site
  } = useAdmin();
  return <div data-id="element-893" data-mp="3pa6i8k7ecchn">
      <PageHeader title="Protocollen" description="Complete routines die je als geheel aanbiedt. De prijs is altijd de som van de producten — die hoef je dus nooit zelf bij te houden." actions={<Link to="/be/protocollen/nieuw" className={btnPrimary} data-id="element-895" data-mp="25fpwhdicw2x">
            <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-896" data-mp="25612x478uyt" />
            Nieuw protocol
          </Link>} data-id="element-894" data-mp="3p9entcpjcksy" />
      <OfferTabs data-id="element-897" data-mp="bvhh3i15qum2" />

      {catalog.routines.length === 0 ? <EmptyState icon={LayersIcon} title="Nog geen protocollen" text="Stel een protocol samen uit je producten; de prijs rekent zichzelf uit." action={<Link to="/be/protocollen/nieuw" className={btnPrimary} data-id="element-899" data-mp="3fe0y1oedye1k">
              Nieuw protocol
            </Link>} data-id="element-898" data-mp="bxc20wcfimq5" /> : <ul className="grid gap-4 md:grid-cols-2" data-id="element-900" data-mp="3oc4jkkpdfatd">
        {catalog.routines.map(r => {
        const totals = index.routineTotals(r);
        const gift = tierIn(site.giftTiers, totals.price);
        const errors = errorCount(routineChecks(r));
        const treatment = index.treatmentForRoutine(r);
        return <li key={r.id} data-id="element-901" data-mp="18k70jcsfnva5">
              <Link to={`/be/protocollen/${r.id}`} className="flex h-full flex-col rounded-lg border border-line bg-white p-5 transition-colors duration-150 ease-soft hover:border-ink/30" data-id="element-902" data-mp="18nkx24ef1a9o">
                <div className="flex items-start justify-between gap-4" data-id="element-903" data-mp="3enc9c8tuqhlq">
                  <div className="min-w-0" data-id="element-904" data-mp="39npwi0hxr3dg">
                    <p className="text-[12px] text-clay" data-id="element-905" data-mp="39or600jazht2">{r.level === 'Compleet' ? 'Compleet protocol' : 'Startprotocol'}</p>
                    <h2 className="mt-1 font-display text-xl leading-snug text-ink" data-id="element-906" data-mp="2lyeqo4lqaisg">{r.name || 'Naamloos'}</h2>
                  </div>
                  <span className="shrink-0 font-display text-xl text-ink" data-id="element-907" data-mp="2vnyelooat2u6">{euro(totals.price)}</span>
                </div>
                <div className="mt-4 flex -space-x-2" aria-hidden="true" data-id="element-908" data-mp="2qwyekajvu4ng">
                  {totals.items.map(p => <ProductImage key={p.id} src={p.image} title={p.name} className="h-10 w-10 shrink-0 rounded-full border-2 border-white p-1" data-id="element-909" data-mp="236chfebf24s8" />)}
                </div>
                <p className="mt-auto pt-4 text-[13px] text-muted" data-id="element-910" data-mp="dpgyfnekzx2m">
                  {plural(totals.items.length, 'product', 'producten')} · {monthsLabel(r.lasts)}
                  {gift ? ` · ${gift.title.toLowerCase()}` : ''}
                  {treatment ? ` · hoort bij ${treatment.name}` : ''}
                  {errors > 0 && <span className="text-clay" data-id="element-911" data-mp="8rynxskx19si"> · controleer dit protocol</span>}
                </p>
              </Link>
            </li>;
      })}
      </ul>}
    </div>;
}